import { FeesForAmount } from '../../Wallet/FeesForAmount';
import { FeesForAmountSkeleton } from '../../Wallet/FeesForAmountSkeleton';
import { getAppConfig } from '@bts-web/core-app-config';
import { useClientLocale, useClientTranslation } from '@bts-web/utils-lokalise';

interface WithdrawalFeesBreakdownProps {
  amount: string;
  fee: string;
  isLoading?: boolean;
}

export const WithdrawalFeesBreakdown = ({
  amount,
  fee,
  isLoading = false,
}: WithdrawalFeesBreakdownProps) => {
  const { t } = useClientTranslation();

  const { currency } = getAppConfig();

  const locale = useClientLocale();

  const parsedAmount = Number(amount);

  const parsedFee = Number(fee);

  if (isLoading) return <FeesForAmountSkeleton lineItemCount={2} />;

  return (
    <FeesForAmount
      lineItems={[
        {
          label: t('fiat_withdrawal_amount'),
          value: Math.max(0, parsedAmount - parsedFee),
        },
        { label: t('fiat_withdrawal_fee'), value: parsedFee },
      ]}
      totalLabel={t('fiat_withdrawal_total')}
      total={parsedAmount}
      currency={currency}
      locale={locale}
    />
  );
};
